import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import de from './locales/de.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';

const resources = {
  en: {
    translation: en
  },
  fr: {
    translation: fr
  },
  es: {
    translation: es
  },
  de: {
    translation: de
  },
  pt: {
    translation: pt
  },
  zh: {
    translation: zh
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    // Remove explicit lng setting to allow detection to work
    debug: false,
    supportedLngs: ['en', 'fr', 'es', 'de', 'pt', 'zh'],
    nonExplicitSupportedLngs: true,

    interpolation: {
      escapeValue: false // React already does escaping
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Don't convert language codes like en-US to just en
      convertDetectedLanguage: (lng) => {
        // Map common language codes to our supported languages
        if (lng.startsWith('en')) return 'en';
        if (lng.startsWith('fr')) return 'fr';
        if (lng.startsWith('es')) return 'es';
        if (lng.startsWith('de')) return 'de';
        if (lng.startsWith('pt')) return 'pt';
        if (lng.startsWith('zh')) return 'zh';
        // Default to English for unsupported languages
        return 'en';
      }
    }
  });

export default i18n;